module.exports = __webpack_public_path__ + "static/media/denise_silva.66444208.png";